var _path, _rect, _path2, _rect2, _path3, _rect3, _path4, _rect4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureStandardize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 128,
    viewBox: "0 0 160 128",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Consistent messages across channels") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 64h25M82 30v67M82 30h19M82 64h19M82 97h19",
    stroke: "#B69782",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 32,
    width: 44,
    height: 64,
    rx: 7,
    fill: "#D7E0EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47h24M23 59h19M23 71h24",
    stroke: "#A6B2C2",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 15,
    width: 45,
    height: 30,
    rx: 5,
    fill: "#45556D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m109 23 15 11 16-11",
    stroke: "#E8EDF3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 51,
    width: 27,
    height: 31,
    rx: 5,
    fill: "#D7E0EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118 60h13M118 67h10M123 76h3",
    stroke: "#596475",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 90,
    width: 41,
    height: 27,
    rx: 5,
    fill: "#D7E0EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113 99h23M113 107h16",
    stroke: "#A6B2C2",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureStandardize);
export default __webpack_public_path__ + "static/media/feature-standardize.3802ee4ae85dac8d671d9ec1b9c2ea0a.svg";
export { ForwardRef as ReactComponent };